import { TestimonialStatusEnum } from "../enums/TestimonialStatusEnum";
import testimonialRepository from "../repositories/TestimonialRepository";
import { TestimonialSortEnum } from "../enums/TestimonialSortEnum";

class TestimonialService {
    constructor() {}

    async create(testimonial, file) {
        const newTestimonial = await testimonialRepository.create(testimonial);
        const videoUpload = await testimonialRepository.uploadVideo(newTestimonial.id, file);

        return videoUpload;
    }

    async getPlayToken(testimonial) {
        return await testimonialRepository.getPlayToken(testimonial);
    }

    async paginatedSearch(page, perPage, status = [TestimonialStatusEnum.active], searchTerm, sort) {
        return testimonialRepository.paginatedSearch(page, perPage, status, searchTerm, TestimonialSortEnum.date, sort);
    }

    async aiSearch(query, page, size, visibility = "", status = "active", includeArchived = false) {
        return await testimonialRepository.aiSearch(query, page, size, visibility, status, includeArchived);
    }

    async getDetails(testimonialId) {
        return await testimonialRepository.getDetail(testimonialId);
    }

    async update(testimonialId, changes) {
        return await testimonialRepository.update(testimonialId, changes);
    }

    async approve(testimonialId) {
        return await testimonialRepository.approve(testimonialId);
    }

    async hardDelete(testimonialId) {
        return await testimonialRepository.hardDelete(testimonialId);
    }

    async googleDriveBulkUpload(payload) {
        return await testimonialRepository.googleDriveBulkUpload(payload);
    }

    async googleDriveBulkUploadStatus(payload) {
        return await testimonialRepository.googleDriveBulkUploadStatus(payload);
    }
}

export default new TestimonialService();
